/**
 * Investor marks, last section above the footer on the homepage.
 * White artwork on transparency; height is driven from CSS so the row
 * stays one line until the cap would be too small to read.
 */

import breyerCapital from "@/assets/images/investors/breyer-capital.svg";
import commonMetal from "@/assets/images/investors/common-metal.svg";
import draper from "@/assets/images/investors/draper.svg";
import finality from "@/assets/images/investors/finality.svg";
import proofGroup from "@/assets/images/investors/proof-group.png";
import salt from "@/assets/images/investors/salt.png";

type Supporter = {
	name: string;
	src: string;
	width: number;
	height: number;
	modifier?: string;
};

const SUPPORTERS: Supporter[] = [
	{ name: "Breyer Capital", src: breyerCapital, width: 232, height: 42 },
	{ name: "Finality Capital Partners", src: finality, width: 165, height: 42 },
	{
		name: "Draper",
		src: draper,
		width: 181,
		height: 37,
		modifier: "supporters-logo--draper",
	},
	{ name: "SALT", src: salt, width: 345, height: 126 },
	{ name: "Proof Group", src: proofGroup, width: 375, height: 126 },
	{ name: "Common Metal", src: commonMetal, width: 113, height: 42 },
];

export function Supporters() {
	return (
		<section
			id="supporters"
			className="px-9 md:px-[8%] lg:px-[15%] pt-16 md:pt-24 pb-20 md:pb-32"
		>
			<h2 className="text-center text-[28px] md:text-[32px] lg:text-[42px] font-sans font-normal tracking-tight text-white">
				Backed by
			</h2>
			<ul className="supporters-row mt-8 md:mt-12">
				{SUPPORTERS.map((logo) => (
					<li key={logo.name}>
						<img
							className={
								logo.modifier
									? `supporters-logo ${logo.modifier}`
									: "supporters-logo"
							}
							src={logo.src}
							alt={logo.name}
							width={logo.width}
							height={logo.height}
							loading="lazy"
							decoding="async"
						/>
					</li>
				))}
			</ul>
		</section>
	);
}
